import React from 'react';
import {
  Avatar,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader
} from '@mui/material';

import {
  Group as GroupIcon,
  MoreVert as MoreVertIcon,
  Person as PersonIcon
} from '@mui/icons-material';
import { observer } from 'mobx-react-lite';

import useStores from '../../stores/useStores';

function AccountList({ onClickSettings, accounts, onSelectAccount }) {
  const { userStore } = useStores();

  const userGroups = accounts.filter(group => group.has_group);
  const adminGroups = accounts.filter(group => !group.has_group);

  const groups = [
    {
      title: 'My Groups',
      groups: userGroups
    }
  ];

  if (adminGroups.length) {
    groups.push({
      title: 'Other Groups',
      groups: adminGroups
    });
  }

  return (
    <List
      subheader={<li />}
      sx={{
        scrollbarWidth: 'thin',
        width: '100%',
        maxHeight: 360
      }}
      dense
    >
      {groups.map(group => (
        <ul
          key={group.title}
          style={{
            paddingLeft: 0
          }}
        >
          <ListSubheader
            style={{
              background: '#fff',
              fontWeight: 400,
              fontSize: '0.8rem',
              borderBottom: '1px solid #DFDFDF'
            }}
          >
            {group.title}
          </ListSubheader>
          {group.groups.map(acc => {
            return (
              <>
                <ListItem
                  id={`group-${acc.id}`}
                  onClick={() => {
                    onSelectAccount(acc);
                  }}
                  key={acc.id}
                  button
                >
                  <ListItemAvatar>
                    <Avatar variant="rounded">
                      {acc.is_user_workspace ? <PersonIcon /> : <GroupIcon />}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primaryTypographyProps={{
                      noWrap: true,
                      textOverflow: 'ellipsis',
                      overflow: 'hidden'
                    }}
                    secondaryTypographyProps={{
                      noWrap: true,
                      textOverflow: 'ellipsis',
                      overflow: 'hidden'
                    }}
                    primary={acc.is_user_workspace ? 'My Workspace' : acc.name}
                    secondary={
                      acc.is_user_workspace
                        ? 'Your personal workspace'
                        : acc.description
                    }
                  />
                  {userStore.isAdmin && (
                    <ListItemSecondaryAction style={{ right: 8 }}>
                      <IconButton
                        onClick={() => {
                          onClickSettings(acc);
                        }}
                        component="span"
                        size="large"
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  )}
                </ListItem>
              </>
            );
          })}
        </ul>
      ))}
    </List>
  );
}

export default observer(AccountList);
